// extracted by css-extract-rspack-plugin
export default {"message":"message-szwbVx","icon":"icon-V4QJWO","messageContent":"messageContent-fui89S"};